// extracted by mini-css-extract-plugin
export default {"container":"z0-z","list":"A0-z"};